module.exports = __webpack_public_path__ + "img/00047.a2b009d3.webp";